import { useEffect } from 'react'

import { EVENT_NAME_ONLINE } from '../../../../../constants/event'
import { GretaAIChatStatus } from '../../../GretaAIChat.constants'
import { getIsGretaAIChatOffline } from '../../../GretaAIChat.utils'

export function useGretaAIChatOnlineRecovery({
  messages,
  reloadMessages,
  setStatus,
  status,
}) {
  useEffect(() => {
    function handleOnline() {
      if (getIsGretaAIChatOffline(status)) {
        if (messages.length === 0) {
          reloadMessages()
        } else {
          setStatus(GretaAIChatStatus.Idle)
        }
      }
    }

    window.addEventListener(EVENT_NAME_ONLINE, handleOnline)

    return () => window.removeEventListener(EVENT_NAME_ONLINE, handleOnline)
  }, [messages, reloadMessages, status])
}
